import { render } from "./TabContent.vue?vue&type=template&id=9dd5515a"
import script from "./TabContent.vue?vue&type=script&lang=js"
export * from "./TabContent.vue?vue&type=script&lang=js"

import exportComponent from "/deploy/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__